import createIcon from '../../createIcon';

/**
 * @component @name NorthEast
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDQuNVY2LjVIMTYuMDlMNC41IDE4LjA5TDUuOTEgMTkuNUwxNy41IDcuOTFWMTQuNUgxOS41VjQuNUg5LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NorthEast = createIcon('NorthEast', [
  [
    'path',
    { d: 'M9.5 4.5V6.5H16.09L4.5 18.09L5.91 19.5L17.5 7.91V14.5H19.5V4.5H9.5Z', key: 'kex48c' },
  ],
]);

export default NorthEast;
